import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { Alert, AlertTitle } from '@mui/material';
import { plural, removeNulls } from 'utils';
import { ColumnBox } from 'shared/components/containers';
import { useDispatch } from 'react-redux';
import { openSelectingDevicesDialog } from 'console/selecting-devices-dialog/actions';
import { useBox } from 'shared/hooks/utils';
import { ACLGroupId } from 'shared/device.acl/model/type';
import { createSelector } from '@reduxjs/toolkit';
import { selectDevicesFields } from 'entities/device/lib';
import { useMutationCallback } from 'shared/api/hooks';
import { LoadingButton } from '@mui/lab';
const select_device_ids_with_support_acl = createSelector(selectDevicesFields(['access', 'id']), (devices) => removeNulls(devices.map(({ access, id }) => {
    if (access?.some((acl) => acl.group_id == ACLGroupId.support)) {
        return id;
    }
    return null;
})));
export const useChooseDevicesWithSupportACL = (need_send_acl) => {
    const device_ids_with_support_acl = useAppSelector(select_device_ids_with_support_acl);
    const [choose_device_ids, setChoseDeviceIds] = useState(device_ids_with_support_acl);
    const boxedDeviceIds = useBox(choose_device_ids);
    const [addAclForSupport, isLoading, , error] = useMutationCallback('support/add_support_acl');
    const ChooseDevicesWithSupportACL = useMemo(() => {
        const ChooseDevicesWithSupportACLImpl = (props) => {
            const can_staff_edit = useAppSelector((state) => state.account.can_staff_edit_devices_without_permission);
            const dispatch = useDispatch();
            const onOpenChooseDevicesDialog = useCallback(() => {
                const filter_function = (devices) => devices;
                const on_ok_function = (device_ids) => {
                    setChoseDeviceIds(device_ids);
                    if (need_send_acl) {
                        addAclForSupport({ choose_device_ids: device_ids });
                    }
                };
                dispatch(openSelectingDevicesDialog(filter_function, on_ok_function, boxedDeviceIds.current));
            }, [need_send_acl, addAclForSupport]);
            if (can_staff_edit) {
                return null;
            }
            return (_jsxs(ColumnBox, { children: [_jsxs(Alert, { severity: "info", children: [_jsx(AlertTitle, { children: "\u0423 \u0412\u0430\u0441 \u0441\u0442\u043E\u0438\u0442 \u0437\u0430\u043F\u0440\u0435\u0442 \u043D\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432 \u0431\u0435\u0437 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F." }), "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C \u0442\u0435\u0445.\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438"] }), _jsx(LoadingButton, { variant: "contained", color: "info", onClick: onOpenChooseDevicesDialog, loading: isLoading, children: choose_device_ids.length == 0
                            ? 'Выбрать'
                            : `${plural(choose_device_ids.length, 'Выбрано', 'Выбраны', 'Выбрано')} ${choose_device_ids.length} ${plural(choose_device_ids.length, 'устройство', 'устройства', 'устройств')}` }), error != null && _jsx(Alert, { severity: "error", children: error })] }));
        };
        return ChooseDevicesWithSupportACLImpl;
    }, [choose_device_ids, addAclForSupport, need_send_acl]);
    return [ChooseDevicesWithSupportACL, choose_device_ids];
};
